import Slide from '@/mixins/Slide'
import Graph from './Graph'
import Resize from '@/mixins/Resize'
import IconArrowCircle from '@/components/IconArrowCircle'
import Circle from './Circle'
import { Tween } from '@/pure/Timeline'


export default
{
    mixins: [
        Slide,
        Resize
    ],

    components: {
        IconArrowCircle
    },

    data()
    {
        return {
            currentGraphIndex: 1,
            currentPointIndex: -1
        }
    },

    computed:
    {
        content()
        {
            return this.$store.slide08
        }
    },

    watch:
    {
        '$store.slide08': 'drawGraphs'
    },

    mounted()
    {
        const size = 40
        this.margin = {
            top: size,
            right: size,
            bottom: size,
            left: size
        }

        const root = document.documentElement
        root.style.setProperty('--graph-margin', size + 'px')

        this.angle = 0
        this.round = new Circle()
        this.drawGraphs()
        this.onHover(1, 0)
    },

    destroyed()
    {
        if (this.tween)
        {
            this.tween.remove()
        }
    },

    methods:
    {
        drawGraph(num)
        {
            const graphWidth = this.$refs['svg' + num].offsetWidth
            const graphHeight = this.$refs['svg' + num].offsetHeight

            const root = document.documentElement
            root.style.setProperty('--graph-' + num + '-width', graphWidth + 'px')
            root.style.setProperty('--graph-height', graphHeight + 'px')

            if (this['graph' + num])
            {
                this['graph' + num].resize(graphWidth, graphHeight).reset()
            }
            else
            {
                const graphID = num - 1
                const domains = [
                    [
                        { x: 2014, y: 0 },
                        { x: 2020.435, y: 160 },
                    ],
                    [
                        { x: 2019, y: 0 },
                        { x: 2024, y: 1524 },
                    ]
                ]

                const points = this.content.graph[graphID].list.map(data => ({ x: data.year, y: data.value }))
                const getIndexByValue = point => points.findIndex(({x, y}) => x === point.x && y === point.y)

                const mainPoints = points.filter((_, index) => num === 1 ? index < 6 : index > 0)
                const secondPoints = points.filter((_, index) => num === 1 ? index > 4 : index < 2)

                this['graph' + num] = new Graph(this.$refs['svg' + num])
                    .resize(graphWidth, graphHeight)
                    .init({
                        mainPoints,
                        secondPoints,
                        domain: domains[num - 1],
                        margin: this.margin
                    })

                this['graph' + num].onOver.add(point => this.onHover(num, getIndexByValue(point)))
                this['graph' + num].onClick.add(point => this.onHover(num, getIndexByValue(point)))
            }
        },

        drawGraphs()
        {
            if (!this.content)
            {
                return
            }

            this.drawGraph(1)
            this.drawGraph(2)
        },

        onResized()
        {
            this.drawGraphs()
        },

        changeGraph(graphID)
        {
            this.onOut(this.currentGraphIndex, this.currentPointIndex)
            // this.currentGraphIndex = graphID
            // this.currentPointIndex =

            this.onHover(graphID, graphID === 1 ? 5 : 1)
        },

        onHover(graphID, pointIndex)
        {
            this.onOut(this.currentGraphIndex, this.currentPointIndex)

            const currentIndex = pointIndex - (graphID - 1)
            const legend = this.$refs['graph' + graphID + 'point'][currentIndex]
            if (legend)
            {
                legend.classList.add('is-visible')
            }

            this.currentGraphIndex = graphID
            this.currentPointIndex = pointIndex


            this.round.update(this.$refs.mapCircle, 94, 94, this.angle)
            if (this.tween)
            {
                this.tween.remove()
            }
            const max1 = this.content.graph[0].list.filter(data => data.text).length
            const max2 = this.content.graph[1].list.filter(data => data.text).length
            const current = currentIndex + (graphID > 1 ? max1 : 0)
            const total = max1 + max2 - 1
            this.tween = new Tween({ from: this.angle, to: current / total, duration: 1000, delay: 0, easing: [.5, 0, 0, 1] })
                .onTick(val =>
                {
                    this.angle = val
                    this.round.update(this.$refs.mapCircle, 94, 94, val)
                })
        },

        onOut(graphID, pointIndex)
        {
            const legend = this.$refs['graph' + graphID + 'point'][pointIndex - (graphID - 1)]
            if (legend)
            {
                legend.classList.remove('is-visible')
            }

            this.currentGraphIndex = graphID
            this.currentPointIndex = -1
        },

        previous()
        {
            if(this.currentGraphIndex === 2)
            {
                this.changeGraph(1)
                return true
            }

            return false
        },

        next()
        {
            if(this.currentGraphIndex === 1)
            {
                this.changeGraph(2)
                return true
            }

            return false
        }
    }
}
